// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var GraphqlHelpers = require("../../GraphqlHelpers.bs.js");
var CommonTypes_ShiftType = require("../CommonTypes_ShiftType.bs.js");
var CommonTypes_Worker_Id = require("../worker/CommonTypes_Worker_Id.bs.js");

var Raw = {};

function parse(value) {
  var value$1 = value.fullName;
  var value$2 = value.shiftCount;
  var value$3 = value.shiftTypeId;
  var value$4 = value.workerId;
  return {
          fullName: !(value$1 == null) ? value$1 : undefined,
          shiftCount: !(value$2 == null) ? GraphqlHelpers.Int.parse(value$2) : undefined,
          shiftTypeId: !(value$3 == null) ? Caml_option.some(Curry._1(CommonTypes_ShiftType.Id.GraphQL_API.parse, value$3)) : undefined,
          workerId: !(value$4 == null) ? Caml_option.some(CommonTypes_Worker_Id.GraphQL_API.parse(value$4)) : undefined
        };
}

function serialize(value) {
  var value$1 = value.workerId;
  var workerId = value$1 !== undefined ? Curry._1(CommonTypes_Worker_Id.GraphQL_API.serialize, Caml_option.valFromOption(value$1)) : null;
  var value$2 = value.shiftTypeId;
  var shiftTypeId = value$2 !== undefined ? Curry._1(CommonTypes_ShiftType.Id.GraphQL_API.serialize, Caml_option.valFromOption(value$2)) : null;
  var value$3 = value.shiftCount;
  var shiftCount = value$3 !== undefined ? GraphqlHelpers.Int.serialize(value$3) : null;
  var value$4 = value.fullName;
  var fullName = value$4 !== undefined ? value$4 : null;
  return {
          fullName: fullName,
          shiftCount: shiftCount,
          shiftTypeId: shiftTypeId,
          workerId: workerId
        };
}

function verifyArgsAndParse(_CommonTypes_Business_RequestableWorker, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var fullName = param.fullName;
  if (fullName === undefined) {
    return ;
  }
  var shiftCount = param.shiftCount;
  if (shiftCount === undefined) {
    return ;
  }
  var shiftTypeId = param.shiftTypeId;
  if (shiftTypeId === undefined) {
    return ;
  }
  var workerId = param.workerId;
  if (workerId !== undefined) {
    return Relude_Option.pure({
                fullName: fullName,
                shiftCount: shiftCount,
                shiftTypeId: Caml_option.valFromOption(shiftTypeId),
                workerId: Caml_option.valFromOption(workerId)
              });
  }
  
}

function compare(param, param$1) {
  return Curry._2(CommonTypes_Worker_Id.compare, param.workerId, param$1.workerId);
}

function eq(param, param$1) {
  return Curry._2(CommonTypes_Worker_Id.eq, param.workerId, param$1.workerId);
}

function compareByName(a, b) {
  var other = Curry._2(Relude_String.compare, a.fullName, b.fullName);
  if (other === "equal_to") {
    return compare(a, b);
  } else {
    return other;
  }
}

var Ord = {
  compare: compare,
  eq: eq
};

var $$Set = Relude_Set.WithOrd({
      eq: eq,
      compare: compare
    });

var query = "fragment CommonTypes_Business_RequestableWorker on BusinessesRequestableWorkersRecord   {\nfullName  \nshiftCount  \nshiftTypeId  \nworkerId  \n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.compare = compare;
exports.eq = eq;
exports.compareByName = compareByName;
exports.Ord = Ord;
exports.$$Set = $$Set;
/* Set Not a pure module */
